import type { BuildOverlayRoutes } from "./types";

const DRAFT_RGB: [number, number, number] = [59, 130, 246];

export const buildOverlayRoutes: BuildOverlayRoutes = ({
  routes,
  byGroupLabel,
  activeIndex,
}) =>
  routes
    .filter((row) => row.nodes.length > 0)
    .map((row, index) => {
      const existingGroup = byGroupLabel[row.routeTypeName];
      const rgb: [number, number, number] = existingGroup?.rgb ?? DRAFT_RGB;
      return {
        id: row.id,
        nodes: row.nodes.map((node) => ({
          id: node.id,
          x: node.x,
          y: node.y,
        })),
        edges: row.edges.map((edge) => ({ from: edge.from, to: edge.to })),
        rgb,
        isActive: index === activeIndex,
      };
    });
